import React, { useState } from "react";
import BaseModal from "../../../BaseComponents/BaseModal";
import { useFormik } from "formik";
import {
  cycleDateRadio,
  cycleOption,
  formikvalidationFunction,
  getReports,
  pdfExcelRadio,
  reportEnums,
  reportPayloadFunction,
} from "../../../Constant/Report/report";
import { Submit } from "../../../Constant";
import BaseSelect from "../../../BaseComponents/BaseSelect";
import { SelectPlaceHolder } from "../../../Constant/validation";
import BaseRadioGroup from "../../../BaseComponents/BaseRadio";
import { PlaceHolderFormat } from "../../../Constant/requireMessage";
import BaseDatePicker from "../../../BaseComponents/BaseDatePicker";
import {
  accountDetailApi,
  dailyAttendanceReportApi,
  exitEmployeeApi,
  leaveBalanceApi,
  leaveSummaryApi,
  payrollAttendanceReportApi,
  staffAttendanceMusterApi,
  staffDetailApi,
} from "../../../Api/reportApi";
import {
  blobErrHandler,
  checkStatusCodeSuccess,
  fileDownload,
  isRequired,
  rendorBackButton,
} from "../../../Constant/common";
import { toast } from "react-toastify";
import { reportTitle } from "../../../Constant/title";
import { useNavigate } from "react-router-dom";
import { useSelectedCenter } from "../../CenterContext";
import { usePageLoader } from "../../../_helper/loading/LoadingContext";
import {
  Download,
  FileText,
  BarChart2,
  Users,
  Calendar,
  Clock,
  DollarSign,
  GitBranch,
  AlertCircle,
} from "react-feather";

const REPORT_ICONS = {
  [reportEnums.exitEmployee]: { Icon: Users, color: "#f43f5e", bg: "rgba(244,63,94,0.1)" },
  [reportEnums.musterRoll]: { Icon: Calendar, color: "#6366f1", bg: "rgba(99,102,241,0.1)" },
  [reportEnums.dailyAttendance]: { Icon: Clock, color: "#10b981", bg: "rgba(16,185,129,0.1)" },
  [reportEnums.attendancePayroll]: {
    Icon: DollarSign,
    color: "#f59e0b",
    bg: "rgba(245,158,11,0.1)",
  },
  [reportEnums.accountDetail]: { Icon: BarChart2, color: "#8b5cf6", bg: "rgba(139,92,246,0.1)" },
  [reportEnums.staffDetail]: { Icon: FileText, color: "#06b6d4", bg: "rgba(6,182,212,0.1)" },
  [reportEnums.leaveBalance]: { Icon: GitBranch, color: "#f97316", bg: "rgba(249,115,22,0.1)" },
  [reportEnums.leaveSummary]: { Icon: AlertCircle, color: "#10b981", bg: "rgba(16,185,129,0.1)" },
};

const Report = () => {
  const [btnLoader, setBtnLoader] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentReport, setCurrentReport] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [isPdf, setIsPdf] = useState(false);
  const maxRange = new Date();
  document.title = reportTitle;
  const navigate = useNavigate();
  const reports = getReports(setCurrentReport);
  const { selectedCenterPayload } = useSelectedCenter();
  const { setLoading } = usePageLoader();

  const toggleModal = () => {
    setModal((m) => !m);
  };

  const apicall = (report, payload) => {
    const xlsxType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const pdfType = "application/pdf";
    const cases = {
      [reportEnums.exitEmployee]: [exitEmployeeApi, xlsxType, reportEnums.exitEmployeeName],
      [reportEnums.musterRoll]: [
        staffAttendanceMusterApi,
        isPdf ? pdfType : xlsxType,
        reportEnums.musterRollName,
      ],
      [reportEnums.dailyAttendance]: [
        dailyAttendanceReportApi,
        isPdf ? pdfType : xlsxType,
        reportEnums.dailyAttendanceName,
      ],
      [reportEnums.attendancePayroll]: [
        payrollAttendanceReportApi,
        pdfType,
        reportEnums.attendancePayrollName,
      ],
      [reportEnums.accountDetail]: [accountDetailApi, xlsxType, reportEnums.accountDetailName],
      [reportEnums.staffDetail]: [staffDetailApi, xlsxType, reportEnums.staffDetailName],
      [reportEnums.leaveBalance]: [leaveBalanceApi, xlsxType, reportEnums.leaveBalanceName],
      [reportEnums.leaveSummary]: [leaveSummaryApi, xlsxType, reportEnums.leaveSummaryName],
    };
    const [apiFn, type, name] = cases[report] || [];
    if (!apiFn) return;
    return apiFn(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.status)) {
          fileDownload(resp?.data, type, name);
          toast.success(resp?.success || resp?.data);
          formik.resetForm();
        } else toast.error(resp);
      })
      .catch(blobErrHandler)
      .finally(() => {
        setBtnLoader(false);
        setIsPdf(false);
        setModal(false);
        setLoading(false);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      report_cycle: null,
      date_range_from: null,
      date_range_end: null,
      cycle_date: null,
      pdf_excel: null,
      attendance_detail: null,
      attendance_date: null,
      cycle: null,
    },
    validationSchema: formikvalidationFunction(currentReport, dateRange),
    onSubmit: () => {
      setBtnLoader(true);
      const payload = reportPayloadFunction(
        currentReport,
        formik,
        selectedCenterPayload,
        dateRange,
      );
      apicall(currentReport, payload);
    },
  });

  return (
    <div className="animate-fade-in" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* Header */}
      <div
        className="animate-slide-down"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "1.375rem",
              fontWeight: 800,
              margin: 0,
              color: "var(--text-primary)",
            }}
          >
            {reportEnums.report}
          </h1>
          <p style={{ margin: 0, fontSize: "0.8125rem", color: "var(--text-muted)", marginTop: 2 }}>
            Generate and download attendance and payroll reports
          </p>
        </div>
        {rendorBackButton(() => navigate("/setting"))}
      </div>

      {/* Report cards grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: 12,
        }}
      >
        {reports.map((report, i) => {
          const cfg = REPORT_ICONS[report.title] || {
            Icon: FileText,
            color: "#64748b",
            bg: "rgba(100,116,139,0.1)",
          };
          const { Icon } = cfg;
          return (
            <div
              key={i}
              className="animate-slide-up"
              style={{
                animationDelay: `${i * 40}ms`,
                background: "var(--glass-bg)",
                border: "1px solid var(--glass-border)",
                borderRadius: 16,
                padding: "18px 20px",
                display: "flex",
                flexDirection: "column",
                gap: 14,
                transition: "box-shadow 0.2s, transform 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = `0 8px 24px ${cfg.color}20`;
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    flexShrink: 0,
                    background: cfg.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon size={20} strokeWidth={1.75} style={{ color: cfg.color }} />
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div
                    style={{ fontWeight: 700, fontSize: "0.9375rem", color: "var(--text-primary)" }}
                  >
                    {report.title}
                  </div>
                  <div
                    style={{
                      fontSize: "0.75rem",
                      color: "var(--text-muted)",
                      marginTop: 3,
                      lineHeight: 1.4,
                    }}
                  >
                    {report.subtitle}
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  report.stateSetter();
                  toggleModal();
                }}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  padding: "8px 14px",
                  borderRadius: 9,
                  width: "100%",
                  background: cfg.bg,
                  border: `1px solid ${cfg.color}30`,
                  color: cfg.color,
                  fontSize: "0.8125rem",
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "all 0.15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `${cfg.color}25`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = cfg.bg;
                }}
              >
                <Download size={14} strokeWidth={2} />
                {reportEnums.generate}
              </button>
            </div>
          );
        })}
      </div>

      {/* Generate modal */}
      <BaseModal
        isOpen={modal}
        title={currentReport}
        toggler={toggleModal}
        submit={formik.handleSubmit}
        submitText={Submit}
        disabled={btnLoader}
        loader={btnLoader}
      >
        <form
          onSubmit={formik.handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 14 }}
        >
          {currentReport === reportEnums.musterRoll && (
            <div>
              <div className="form-label mb-1">
                {reportEnums.downloadBy}
                {isRequired}
              </div>
              <BaseRadioGroup
                name="cycle_date"
                options={cycleDateRadio}
                selectedValue={formik.values.cycle_date}
                onChange={(e) => {
                  setDateRange(e.target.value);
                  formik.setFieldValue("cycle_date", e.target.value);
                }}
                value={formik.values.cycle_date}
                touched={formik.touched.cycle_date}
                error={formik.errors.cycle_date}
                handleBlur={formik.handleBlur}
              />
            </div>
          )}
          {currentReport === reportEnums.musterRoll && dateRange === reportEnums.dateRange && (
            <div>
              <div className="form-label mb-1">{reportEnums.dateRange}</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                <BaseDatePicker
                  name="date_range_from"
                  label={reportEnums.reportCycleFrom}
                  value={formik.values.date_range_from}
                  onChange={(v) => formik.setFieldValue("date_range_from", v)}
                  onBlur={formik.handleBlur}
                  touched={formik.touched.date_range_from}
                  error={formik.errors.date_range_from}
                  placeholder={PlaceHolderFormat(reportEnums.reportCycleFrom)}
                  required
                />
                <BaseDatePicker
                  name="date_range_end"
                  label={reportEnums.reportCycleEnd}
                  value={formik.values.date_range_end}
                  onChange={(v) => formik.setFieldValue("date_range_end", v)}
                  onBlur={formik.handleBlur}
                  touched={formik.touched.date_range_end}
                  error={formik.errors.date_range_end}
                  placeholder={PlaceHolderFormat(reportEnums.reportCycleEnd)}
                  required
                />
              </div>
            </div>
          )}
          {(currentReport === reportEnums.exitEmployee ||
            (currentReport === reportEnums.musterRoll && dateRange === reportEnums.salaryCycle) ||
            currentReport === reportEnums.leaveSummary) && (
            <div>
              <label className="form-label">
                {reportEnums.reportCycle}
                {isRequired}
              </label>
              <BaseDatePicker
                name="report_cycle"
                value={
                  formik.values.report_cycle
                    ? formik.values.report_cycle instanceof Date
                      ? formik.values.report_cycle.toISOString().slice(0, 7)
                      : formik.values.report_cycle
                    : ""
                }
                onChange={(val) => formik.setFieldValue("report_cycle", val)}
                onBlur={formik.handleBlur}
                touched={formik.touched.report_cycle}
                error={formik.errors.report_cycle}
                placeholder={reportEnums.reportCycle}
                showMonthYearPicker
                maxDate={maxRange}
              />
            </div>
          )}
          {currentReport === reportEnums.dailyAttendance && (
            <BaseDatePicker
              label={reportEnums.attendanceDate}
              name="attendance_date"
              value={formik.values.attendance_date}
              onChange={(v) => formik.setFieldValue("attendance_date", v)}
              onBlur={formik.handleBlur}
              touched={formik.touched.attendance_date}
              error={formik.errors.attendance_date}
              placeholder={PlaceHolderFormat(reportEnums.attendanceDate)}
              required
            />
          )}
          {currentReport === reportEnums.attendancePayroll && (
            <BaseSelect
              name="cycle"
              label={reportEnums.cycle}
              options={cycleOption}
              placeholder={SelectPlaceHolder(reportEnums.cycle)}
              handleChange={(field, value) => formik.setFieldValue(field, value)}
              handleBlur={() => formik.setFieldTouched("cycle", true)}
              value={formik.values.cycle}
              touched={formik.touched.cycle}
              error={formik.errors.cycle}
              required
            />
          )}
          {(currentReport === reportEnums.musterRoll ||
            currentReport === reportEnums.dailyAttendance) && (
            <div>
              <div className="form-label mb-1">
                {reportEnums.reportType}
                {isRequired}
              </div>
              <BaseRadioGroup
                name="pdf_excel"
                options={pdfExcelRadio}
                selectedValue={formik.values.pdf_excel}
                onChange={(e) => {
                  formik.setFieldValue("pdf_excel", e.target.value);
                  if (e.target.value === reportEnums.PDF) setIsPdf(true);
                }}
                value={formik.values.pdf_excel}
                touched={formik.touched.pdf_excel}
                error={formik.errors.pdf_excel}
                handleBlur={formik.handleBlur}
                required
              />
            </div>
          )}
          {(currentReport === reportEnums.accountDetail ||
            currentReport === reportEnums.staffDetail ||
            currentReport === reportEnums.leaveBalance) && (
            <p style={{ margin: 0, fontSize: "0.875rem", color: "var(--text-muted)" }}>
              {reportEnums.confirmationText}
            </p>
          )}
        </form>
      </BaseModal>
    </div>
  );
};

export default Report;
